import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Landmark } from "lucide-react";
import Overview from "./governance/Overview";
import Documents from "./governance/Documents";
import Agreements from "./governance/Agreements";
import Register from "./governance/Register";
import Dpia from "./governance/Dpia";
import Accounts from "./governance/Accounts";
import AuditLog from "./governance/AuditLog";

const TABS = [
  ["overview", "Overview", <Overview />],
  ["documents", "Documents", <Documents />],
  ["agreements", "Organisations & Agreements", <Agreements />],
  ["dpia", "DPIA & Risk", <Dpia />],
  ["suppliers", "Subprocessors", <Register kind="suppliers" />],
  ["incidents", "Security & Incidents", <Register kind="incidents" />],
  ["controls", "Evidence", <Register kind="controls" />],
  ["accounts", "Accounts", <Accounts />],
  ["audit", "Audit trail", <AuditLog />],
];

export default function Governance() {
  return (
    <div className="space-y-6" data-testid="governance-page">
      <div>
        <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-[#2F6DA3] mb-1">Castlewood Software · Super Admin</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter flex items-center gap-3">
          <Landmark size={36} className="text-[#2F6DA3]" /> Governance Centre
        </h1>
        <p className="text-sm text-zinc-500 mt-2 max-w-3xl">Obligations, evidence, agreements and risks for CPH Contract Intelligence. Drafts are not legal advice and are not binding until approved.</p>
      </div>
      <Tabs defaultValue="overview">
        <TabsList className="flex flex-wrap h-auto bg-white border-2 border-[#14304F] p-1 rounded-none">
          {TABS.map(([v, l]) => (
            <TabsTrigger key={v} value={v} data-testid={`gov-tab-${v}`} className="rounded-none text-xs font-bold uppercase tracking-wider data-[state=active]:bg-[#14304F] data-[state=active]:text-white">{l}</TabsTrigger>
          ))}
        </TabsList>
        {TABS.map(([v, , el]) => <TabsContent key={v} value={v} className="mt-5">{el}</TabsContent>)}
      </Tabs>
    </div>
  );
}
